// Lib
import { ModelSyncState } from './reducer';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { PublishResult } from './types';

export interface ActionPublishAPI extends Action {
    idengine?: string
    iddealer?: string
    syncType?: string
}

export const publishAPI = (idengine?: string, iddealer?: string, syncType?: string): ActionPublishAPI => ({
    type: ACTIONS.PUBLISH_API_REQUEST,
    idengine,
    iddealer,
    syncType
});


export const publishCleanResult = () => ({
    type: ACTIONS.PUBLISH_CLEAN_RESULT
});

export interface ActionPublishAPISuccess extends Action {
    result: PublishResult
}

export const publishAPISuccess = (result: PublishResult): ActionPublishAPISuccess => ({
    type: ACTIONS.PUBLISH_API_SUCCESS,
    result
});

export const publishAPIError = (): Action => ({
    type: ACTIONS.PUBLISH_API_ERROR,
});
